import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { from, Observable } from 'rxjs';
import { concatMap, map, startWith } from 'rxjs/operators';
import { GeneralService } from 'src/app/services/general.service';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { BraquetService } from './braquet.service';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';

import { StructureRechercheCircuit } from './braquet.const';
@Component({
  selector: 'app-braquet',
  templateUrl: './braquet.component.html',
  styleUrls: ['./braquet.component.scss'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { showError: true },
    },
  ],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
})
export class BraquetComponent implements OnInit {
  exist: boolean = true;

  date_Fin: any;
  date_Debut: any;
  longRangeTime = '20000101,21001211';

  listeReservation = [];
  DS_circuit;
  circuitCtrl = new FormControl();
  filteredCircuit: Observable<any[]>;

  listHotels_fournisseurs = [];
  listRestaurants = [];
  displayedColumnsHotel: string[] = ['day', 'tiers-rs', 'tiers-ville'];
  displayedColumnsResto: string[] = [
    'day',
    'tiers-rs',
    'tiers-event',
    'tiers-ville',
  ];
  displayedColumnsTarif: string[] = [
    'Tarif_index',
    'Type',
    'Tarif',
    'Date_Deb',
    'Date_Fin',
    'Tiers_code',
    'Valide',
  ];

  clickedRows = new Set<any>();

  displayedColumnsPreviewTarif: string[] = [
    'periode',
    'Date_Deb',
    'Date_Fin',
    'Tarif',
  ];
  expandedTable;
  listeEvennement = [];
  listNbrPerso = [];

  PeriodsList = [];

  firstFormGroup: FormGroup;
  // secondFormGroup: FormGroup;
  constructor(
    public generalService: GeneralService,
    private router: Router,
    public braquetService: BraquetService,
    private _formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required],
    });
    // this.secondFormGroup = this._formBuilder.group({
    //   secondCtrl: ['', Validators.required],
    // });

    if (!this.braquetService.getTravel_codeFromBraquetMatrixResult()) {
      this.date_Fin = new Date();
      this.date_Debut = new Date('01-01-2022');
      this.date_Fin = new Date(
        this.date_Fin.setDate(this.date_Fin.getDate() + 365)
      );
    }
    this.getListeReservation();
    this.getDataFromLocalStorage();
    this.getListEvenement();
    setTimeout(() => {
      console.log(this.PeriodsList);
    }, 1000);
  }

  getDataFromLocalStorage() {
    if (this.braquetService.getTravel_codeFromBraquetMatrixResult()) {
      this.getDetailCircuit_byTravelCode(
        this.braquetService.getTravel_codeFromBraquetMatrixResult()
      )
        .then(() => {
          console.log(this.braquetService.getBraquetInitialConfig());

          this.matrixResult =
            this.braquetService.getSharedBraquetMatrixResult();
          this.date_Debut =
            this.braquetService.getBraquetInitialConfig()['date_deb'];
          this.date_Fin =
            this.braquetService.getBraquetInitialConfig()['date_fin'];

          this.setUpDisplayedBraquet();
        })
        .catch((error) => {
          // Handle errors if any
          console.error(error);
        });
    }
  }

  getListEvenement() {
    this.generalService
      .rechercheTable2('Api_listeEvennement')
      .subscribe((res: any) => {
        this.listeEvennement = res;
      });
  }

  onSelectCircuit(event) {
    console.log(event);
    this.firstFormGroup.setValue({
      firstCtrl: event,
    });
    this.getDetailCircuit_byTravelCode(event);
  }

  setUpDisplayedBraquet() {
    const nbPersonneSet = new Set();
    const periodSet = new Set<{
      startDate: string;
      endDate: string;
      values: any[];
      endDateToDisplay: string;
      error: string;
    }>();
    console.log(this.matrixResult);

    for (const subList of this.matrixResult) {
      for (const [index, entry] of subList.entries()) {
        nbPersonneSet.add(entry.nbpersonne);
        const { code, startDate, endDate, nbpersonne, value, error } = entry;
        let endDateToDisplay: string;
        if (index < subList.length - 1) {
          console.log(
            this.calculateDaysBetweenDates(
              subList[index].startDate,
              subList[index + 1].startDate
            )
          );

          if (
            this.calculateDaysBetweenDates(
              subList[index].startDate,
              subList[index + 1].startDate
            ) >= this.DS_circuit?.Travel[0].Travel_NbJour
          )
            endDateToDisplay = this.getDayBefore(
              new Date(subList[index + 1].startDate)
            ).toISOString();
          else endDateToDisplay = subList[index].endDate;
        } else {
          endDateToDisplay = this.date_Fin; // Last item in the list
        }
        const period = {
          startDate,
          endDate,
          nbpersonne,
          values: [{ code: code, value: value }],
          endDateToDisplay,
          error,
        };
        let found = false;
        for (const existingPeriod of periodSet) {
          if (
            existingPeriod.startDate === period.startDate &&
            existingPeriod.endDate === period.endDate
          ) {
            found = true;
            existingPeriod.values.push({ code: code, value: value });
            break;
          }
        }
        if (!found) {
          periodSet.add(period);
        }
      }
    }
    this.listNbrPerso = Array.from(nbPersonneSet);
    this.PeriodsList = Array.from(periodSet);
    console.log(this.DS_circuit?.Travel[0].Travel_NbJour);

    console.log(this.PeriodsList);
  }

  getDayBefore(date: Date): Date {
    const dayBefore = new Date(date);
    dayBefore.setDate(date.getDate() - 1);
    return dayBefore;
  }

  calculateDaysBetweenDates(date1, date2) {
    // Convert both dates to milliseconds
    const date1Ms = new Date(date1).setHours(0, 0, 0, 0); // Reset time to midnight for accurate day count
    const date2Ms = new Date(date2).setHours(0, 0, 0, 0);

    // Calculate the difference in milliseconds
    const differenceMs = Math.abs(date2Ms - date1Ms);

    // Convert the difference from milliseconds to days
    const differenceDays = Math.floor(differenceMs / (1000 * 60 * 60 * 24)) + 1;

    return differenceDays;
  }

  getColorClass(indexPeriod: number): string {
    if (indexPeriod % 3 === 0) {
      return 'color green';
    } else if (indexPeriod % 3 === 1) {
      return 'color blue';
    } else if (indexPeriod % 3 === 2) {
      return 'color crimson';
    } else {
      return 'color blue';
    }
  }

  trackByIndex(index: number, item: any): any {
    return item.code || index;
  }

  removDataFromLocalStorageAndResetValues() {
    this.braquetService.removeListFromLocalStorage();

    this.braquetService.loadListFromLocalStorage();

    this.braquetService.BraquetMatrixResult = null;
    this.braquetService.Travel_code = null;
    this.DS_circuit = null;
    this.PeriodsList = [];
    this.matrixResult = [];
    this.listNbrPerso = [];
    this.backUp_listeTarif = [];
    this.listeTarif = [];
    this.listHotels_fournisseurs = [];
  }

  getListeReservation() {
    this.generalService
      .rechercheTable(
        this.generalService.url + 'Travel&param=' + this.longRangeTime
      )
      .subscribe(
        (data) => {
          console.log(data);
          this.listeReservation = data;

          this.filteredCircuit = this.circuitCtrl.valueChanges.pipe(
            startWith(''),
            map((circuit) =>
              circuit
                ? this._filterCircuits(circuit)
                : this.listeReservation.slice()
            )
          );
          this.exist = true;
        },
        () => {
          this.exist = true;
          this.generalService.dialogSuccess('pas de donnée disponible', false);
        }
      );
  }

  private _filterCircuits(value): any[] {
    console.log(typeof value);
    let filterValue;
    if (typeof value == 'object')
      filterValue = value['Travel_Nom'].toLowerCase();
    else filterValue = value.toLowerCase();

    return this.listeReservation.filter((state) =>
      state.Travel_Nom.toLowerCase().includes(filterValue)
    );
  }

  displayFn(circuit?: any): string | undefined {
    return circuit ? circuit.Travel_Nom : undefined;
  }

  getDetailCircuit_byTravelCode(Travel_Code) {
    return new Promise<void>((resolve, reject) => {
      this.generalService.getDS('Travel', Travel_Code).subscribe(
        (circuit) => {
          console.log(circuit);
          this.DS_circuit = circuit;
          this.get_Hotels_fournisseurs(circuit);
          this.get_AllRestaurants(circuit);
          resolve(); // Resolve the promise once processing is done
        },
        (error) => {
          // Reject the promise if there's an error
          reject(error);
        }
      );
    });
  }

  //! get list forunisseurs from selected circuits

  get_Hotels_fournisseurs(circuit) {
    const uniqueSuppliers = [];
    const seenTiersCodes = new Set();
    let index = 0;
    circuit.TravelD.forEach((e) => {
      if (
        e.TravelD_TypeEvent == 1 &&
        !seenTiersCodes.has(e.Tiers_code + 'J-' + e.TravelD_Jour)
      ) {
        index++;
        uniqueSuppliers.push({
          Tiers_index: index,
          Tiers_code: e.Tiers_code,
          Tiers_RS: e.Tiers_RS,
          TravelD_Jour: e.TravelD_Jour,
          TravelD_Ville: e.TravelD_Ville,
        });
        seenTiersCodes.add(e.Tiers_code + 'J-' + e.TravelD_Jour);
      }
    });
    this.listHotels_fournisseurs = uniqueSuppliers;
    this.get_allTarifs_forAll_Hotels_inCircuits().then((res) => {
      this.onChangeGlobalDates(circuit);
    });
  }
  get_AllRestaurants(circuit) {
    const uniqueSuppliers = [];
    const seenTiersCodes = new Set();
    let index = 0;
    circuit.TravelD.forEach((e) => {
      if (
        e.TravelD_TypeEvent == 0 &&
        !seenTiersCodes.has(e.Tiers_code + 'J-' + e.TravelD_Jour)
      ) {
        index++;
        uniqueSuppliers.push({
          Tiers_index: index,
          Tiers_code: e.Tiers_code,
          Tiers_RS: e.Tiers_RS,
          TravelD_Jour: e.TravelD_Jour,
          TravelD_Ville: e.TravelD_Ville,
          TravelD_Event: e.TravelD_Event,
        });
        seenTiersCodes.add(e.Tiers_code + 'J-' + e.TravelD_Jour);
      }
    });
    console.log(uniqueSuppliers);

    this.listRestaurants = uniqueSuppliers;
  }

  getStructureRechercheCircuit() {
    return StructureRechercheCircuit;
  }

  onChangeGlobalDates(circuit) {
    if (circuit) {
      const listeTarif = this.filterByLarge_periodOfTime(
        this.backUp_listeTarif,
        this.date_Debut,
        this.date_Fin
      );
      const datesFromTarifs = this.handle_extrairPeriods_fromChanges_tarifs(
        listeTarif,
        circuit.Travel[0].Travel_NbJour
      );
      this.dates_changed_list = datesFromTarifs;

      console.log(this.dates_changed_list);
    }
  }
  handle_extrairPeriods_fromChanges_tarifs(listeTarif, nbrJour) {
    const uniqueDates = new Set();

    uniqueDates.add(moment(this.date_Debut).format('YYYY-MM-DD'));
    listeTarif.forEach((item) => {
      uniqueDates.add(moment(item.Date_Deb).format('YYYY-MM-DD'));
      uniqueDates.add(moment(item.Date_Fin).format('YYYY-MM-DD'));
    });

    const sortedDates = Array.from(uniqueDates).sort();
    const result = [...sortedDates];

    for (let i = 0; i < sortedDates.length; i++) {
      if (i !== 0 && i !== sortedDates.length - 1) {
        const currentDate = moment(sortedDates[i]);

        // Add days before current date
        for (let j = 1; j <= nbrJour; j++) {
          const previousDay = moment(currentDate).subtract(j, 'days');
          if (!sortedDates.includes(previousDay.format('YYYY-MM-DD'))) {
            result.push(previousDay.format('YYYY-MM-DD'));
          }
        }

        // Add current date
        result.push(currentDate.format('YYYY-MM-DD'));

        // Add days after current date
        for (let j = 1; j <= nbrJour; j++) {
          const nextDay = moment(currentDate).add(j, 'days');
          if (!sortedDates.includes(nextDay.format('YYYY-MM-DD'))) {
            result.push(nextDay.format('YYYY-MM-DD'));
          }
        }
      }
    }

    return Array.from(new Set(result)).sort(); // Return unique dates
  }

  generateAdjacentDates(dateDeb: Date, uniqueDates: string[]): string[] {
    const adjacentDates: string[] = [];

    uniqueDates.forEach((dateString) => {
      const currentDate = new Date(dateString);

      const dayBefore = new Date(currentDate);
      dayBefore.setDate(dayBefore.getDate() - 1);
      if (dayBefore > dateDeb) {
        adjacentDates.push(dayBefore.toISOString());
      }

      const dayAfter = new Date(currentDate);
      dayAfter.setDate(dayAfter.getDate() + 1);
      if (dayAfter > dateDeb) {
        adjacentDates.push(dayAfter.toISOString());
      }
    });

    return adjacentDates;
  }

  //! get list des tarifs for each fournisseur then collect them

  listeTarifPerTiers = [];
  listeTarif = [];
  backUp_listeTarifPerTiers = [];
  backUp_listeTarif = [];
  origineTarifs = [];
  fournisseurSelected;
  get_Traifs_byFrournisseur(tiers_code) {
    this.generalService
      .rechercheTable(
        this.generalService.url +
          'API_Tarif&param=' +
          this.longRangeTime +
          ',' +
          tiers_code
      )
      .subscribe(
        (data: any) => {
          console.log(data);
          this.listeTarifPerTiers = data.map((x, index) => {
            return {
              Tarif_index: index + 1,
              Type: x.Type_Tarif,
              Tarif: x.Tarif,
              Date_Deb: x.Date_Deb,
              Date_Fin: x.Date_Fin,
              Tiers_code: x.Tiers_code,
              Valide: x.Valide,
            };
          });
          this.backUp_listeTarifPerTiers = this.listeTarifPerTiers;

          this.exist = true;
        },
        () => {
          this.exist = true;
          this.generalService.dialogSuccess('pas de donnée disponible', false);
        }
      );
  }

  async getPromise_Tarifs_byFrournisseur(tiers_code) {
    return this.generalService
      .rechercheTable(
        this.generalService.url +
          'API_Tarif&param=' +
          this.longRangeTime +
          ',' +
          tiers_code
      )
      .toPromise();
  }

  //! loop on the hotels list to get all the tarifs

  async get_allTarifs_forAll_Hotels_inCircuits() {
    this.listeTarif = [];
    const promises = this.listHotels_fournisseurs.map((hotel) => {
      return this.getPromise_Tarifs_byFrournisseur(hotel.Tiers_code).then(
        async (tarifs) => {
          const ObjectType = await this.generalService
            .rechercheTable2('API_Listetype1', hotel.Tiers_code)
            .toPromise();
          const listType = Object.values(ObjectType);

          const mappedTariflist = tarifs.map((x, index) => {
            return {
              Tarif_index: index + 1,
              Type: listType.find((t) => t.value === x.Type_Tarif)?.text,
              Tarif: x.Tarif,
              Date_Deb: x.Date_Deb,
              Date_Fin: x.Date_Fin,
              Tiers_code: x.Tiers_code,
              Valide: x.Valide,
            };
          });

          this.listeTarif.push(...mappedTariflist);
          return mappedTariflist;
        }
      );
    });

    await Promise.all(promises);

    const filtredList_withValidateTarifs = this.listeTarif.filter(
      (e) => e.Valide == 1
    );
    const listFiltredBy_TargetLarge_periodOfTime =
      this.filterByLarge_periodOfTime(
        filtredList_withValidateTarifs,
        this.date_Debut,
        this.date_Fin
      );

    this.backUp_listeTarif = listFiltredBy_TargetLarge_periodOfTime;
    this.origineTarifs = this.backUp_listeTarif;
  }

  onChangeListTarifs_perPeriod() {
    if (this.listeTarif && this.listeTarif.length > 0) {
      const filtredList_withValidateTarifs = this.listeTarif.filter(
        (e) => e.Valide == 1
      );
      const listFiltredBy_TargetLarge_periodOfTime =
        this.filterByLarge_periodOfTime(
          filtredList_withValidateTarifs,
          this.date_Debut,
          this.date_Fin
        );

      this.backUp_listeTarif = listFiltredBy_TargetLarge_periodOfTime;
    }
  }

  //! filter list tarifs by range of date
  filterByLarge_periodOfTime(data, startDate, endDate) {
    const filteredData = data.filter((item) => {
      const itemStartDate = new Date(item.Date_Deb);
      const itemEndDate = new Date(item.Date_Fin);

      return (
        itemStartDate >= new Date(startDate) && itemEndDate <= new Date(endDate)
      );
    });
    console.log(filteredData);
    console.log(this.date_Debut);
    console.log(this.date_Fin);

    return filteredData;
  }

  addNumberToList(elementRef) {
    const parsedValue = parseInt(elementRef.value, 10);
    if (!isNaN(parsedValue)) {
      this.listNbrPerso.push(parsedValue);
    }
    // Clear input field after adding the number
    elementRef.value = '';
  }
  sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  loadingBraquetCalucul = false;
  matrixResult = [];
  dates_changed_list = [];
  async HandleCalculBraquet(circuit, listNbPersonne) {
    const startDate = new Date(this.date_Debut.getTime());
    const endDate = new Date(this.date_Fin.getTime());
    const nbrJour = circuit.Travel[0].Travel_NbJour;
    let currentDate = new Date(startDate);
    let previousResCalcul = null;
    let startDateRange = null;

    this.PeriodsList = [];
    this.matrixResult = [];
    const matrixArray = []; // Array to store result matrices for each nbPersonne

    if (circuit) this.loadingBraquetCalucul = true;

    for (const nbPersonne of listNbPersonne) {
      const resultMatrix = []; // Result matrix for current nbPersonne

      let currentDate = new Date(startDate); // Reset currentDate for each nbPersonne

      while (currentDate < endDate) {
        const circuitDS = await this.generalService
          .getDS('Travel', circuit.Travel[0].Travel_Code)
          .toPromise();
        let copyCircuit = JSON.parse(JSON.stringify(circuitDS));
        const iterationStartDate = new Date(currentDate.getTime());
        const iterationEndDate = new Date(currentDate.getTime());
        iterationEndDate.setDate(iterationEndDate.getDate() + nbrJour);

        copyCircuit.Travel[0].Travel_NbPerso = nbPersonne; // Set nbPersonne
        copyCircuit.Travel[0].Travel_DateDeb = iterationStartDate;
        copyCircuit.Travel[0].Travel_DateFin = iterationEndDate;
        copyCircuit.Travel[0].Travel_statut1 = 0;
        copyCircuit.TravelDM = [];

        try {
          await this.generalService.enregisterTable(copyCircuit).toPromise();
          const res_calcul = await this.generalService
            .rechercheTable2(
              'API_CalculTotal',
              copyCircuit.Travel[0].Travel_Code
            )
            .toPromise();

          if (
            JSON.stringify(res_calcul) !== JSON.stringify(previousResCalcul)
          ) {
            if (previousResCalcul !== null) {
              const endDateRange = new Date(iterationStartDate.getTime());
              endDateRange.setDate(endDateRange.getDate() - 1);
              resultMatrix.push({
                value: previousResCalcul,
                startDate: startDateRange,
                endDate: endDateRange,
                nbpersonne: nbPersonne,
              });
            }

            previousResCalcul = JSON.parse(JSON.stringify(res_calcul));
            startDateRange = new Date(iterationStartDate.getTime());
          }
        } catch (error) {
          console.error(error);
        }

        currentDate.setDate(currentDate.getDate() + 1);
      }

      if (previousResCalcul !== null) {
        const endDateRange = new Date(endDate.getTime());
        resultMatrix.push({
          value: previousResCalcul,
          startDate: startDateRange,
          endDate: endDateRange,
          nbpersonne: nbPersonne,
        });
      }

      matrixArray.push(resultMatrix); // Push the resultMatrix for current nbPersonne
    }

    console.log(matrixArray); // Log the entire matrixArray
    this.matrixResult = matrixArray; // Assign matrixArray to matrixResult
    this.setUpDisplayedBraquet();
    this.loadingBraquetCalucul = false;
    console.log('All iterations completed');
  }

  // logValue() {
  //   console.log(this.DS_circuit);
  //   console.log(this.listNbrPerso);
  //   console.log(this.dates_changed_list);
  //   console.log(this.DS_circuit?.Travel[0].Travel_NbJour);
  //   console.log(this.date_Debut);
  //   console.log(this.date_Fin);
  //   console.log(this.setStartDates());
  // }
  logValue() {
    console.log(this.PeriodsList);
  }

  setStartDates(): string[] {
    const nbJour = this.DS_circuit?.Travel[0]?.Travel_NbJour;

    if (!this.date_Debut || !this.date_Fin || !nbJour) {
      console.log('Missing required input values');
      return [this.formatDate(this.date_Debut)];
    }

    const start = new Date(this.date_Debut);
    console.log(start);
    console.log(this.date_Fin);

    const end = new Date(this.date_Fin);
    const dates: string[] = [];

    for (
      let d = new Date(start);
      d <= new Date(end.getTime() - (nbJour - 1) * 86400000);
      d.setDate(d.getDate() + 1)
    ) {
      dates.push(this.formatDate(new Date(d)));
    }

    return dates.length ? dates : [this.formatDate(start)];
  }

  /**
   * Formats a Date object as dd-MM-yyyy
   */
  private formatDate(date: Date | string): string {
    const d = new Date(date);
    return d.toLocaleDateString('fr-FR').split('/').reverse().join('-');
  }

  async HandleCalculBraquetPerDates(circuit, listNbPersonne, dateList) {
    const matrixArray = []; // Array to store result matrices for each nbPersonne
    this.braquetService.removeListFromLocalStorage();
    this.counterBRQ = 1;

    if (!circuit || !Array.isArray(dateList) || dateList.length === 0) {
      console.error('Invalid input');
      return;
    }

    this.loadingBraquetCalucul = true;

    for (const nbPersonne of listNbPersonne) {
      const resultMatrix = []; // Result matrix for current nbPersonne

      for (const startDate of dateList) {
        const circuitDS = await this.generalService
          .getDS('Travel', circuit.Travel[0].Travel_Code)
          .toPromise();
        const iterationStartDate = startDate;
        const iterationEndDate = new Date(startDate);

        iterationEndDate.setDate(
          iterationEndDate.getDate() + circuit.Travel[0].Travel_NbJour - 1
        );

        const copyCircuit = JSON.parse(JSON.stringify(circuitDS));
        copyCircuit.Travel[0].Travel_NbPerso = nbPersonne; // Set nbPersonne
        copyCircuit.Travel[0].Travel_DateDeb = iterationStartDate;
        copyCircuit.Travel[0].Travel_DateFin =
          moment(iterationEndDate).format('YYYY-MM-DD');
        copyCircuit.Travel[0].Travel_statut1 = 0;
        copyCircuit.TravelDM = [];

        try {
          await this.generalService.enregisterTable(copyCircuit).toPromise();
          const res_calcul = await this.generalService
            .rechercheTable2(
              'API_CalculTotal',
              copyCircuit.Travel[0].Travel_Code
            )
            .toPromise();

          console.log(
            !this.braquetService.validatCalculCircuit(
              circuit,
              res_calcul,
              this.listeEvennement
            )
          );
          console.log(res_calcul);

          if (
            !this.braquetService.validatCalculCircuit(
              circuit,
              res_calcul,
              this.listeEvennement
            )
          ) {
            if (
              resultMatrix.length === 0 ||
              JSON.stringify(res_calcul) !==
                JSON.stringify(resultMatrix[resultMatrix.length - 1].value)
            ) {
              resultMatrix.push({
                code: this.generateCustomCode(),
                value: JSON.parse(JSON.stringify(res_calcul)),
                startDate: iterationStartDate,
                endDate: iterationEndDate,
                nbpersonne: nbPersonne,
              });
            }
          } else {
            resultMatrix.push({
              code: this.generateCustomCode(),
              value: JSON.parse(JSON.stringify(res_calcul)),
              startDate: iterationStartDate,
              endDate: iterationEndDate,
              nbpersonne: nbPersonne,
              error: 'résultat erroné',
            });
          }
        } catch (error) {
          console.error(error);
        }
      }

      matrixArray.push(resultMatrix); // Push the resultMatrix for current nbPersonne
    }

    console.log(matrixArray); // Log the entire matrixArray
    this.braquetService.BraquetMatrixResult = matrixArray;
    this.braquetService.Travel_code = circuit.Travel[0].Travel_Code;
    this.braquetService.config = {
      date_deb: this.date_Debut,
      date_fin: this.date_Fin,
      nbrPersonneList: this.listNbrPerso,
    };
    this.braquetService.saveListToLocalStorage();
    this.matrixResult = matrixArray; // Assign matrixArray to matrixResult

    this.setUpDisplayedBraquet();
    location.reload();

    this.loadingBraquetCalucul = false;

    console.log('All iterations completed');
  }
  counterBRQ = 1;
  generateCustomCode(): string {
    const paddedCounter = this.counterBRQ.toString().padStart(3, '0'); // Pad the counter with leading zeros if needed
    const customCode = `brq${paddedCounter}`;
    this.counterBRQ++; // Increment the counter for the next call
    return customCode;
  }

  parseISOString(s) {
    var b = s.split(/\D+/);
    return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5], b[6]));
  }

  gotoReservationWithCodeBraquet(Travel_Code, braquet_code) {
    this.router.navigate(['avt/grh/reservation', Travel_Code, '2'], {
      queryParams: {
        braquet: braquet_code,
      },
    });
  }

  removeOptionNbrPerso(index) {
    this.listNbrPerso.splice(index, 1);
  }

  refreshinge = true;
  refresh() {
    this.refreshinge = false;
    setTimeout(() => {
      this.refreshinge = true;
    }, 1000);
  }
}
